"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.privacyPolicy = exports.help = exports.licenses = exports.logging = exports.i18n = exports.core = exports.profile = exports.auth = exports.utils = exports.notificationsBucket = exports.notifications = exports.mfa = exports.skybox = exports.session = exports.permission = exports.analytics = exports.access = exports.preference = exports.environment = void 0;

var _appInfo = require("@onviobr/app-info");

var _environment = _interopRequireWildcard(require("./environment"));

var _preference = _interopRequireWildcard(require("./preference"));

var _access = _interopRequireWildcard(require("./access"));

var _analytics = _interopRequireWildcard(require("./analytics"));

var _permission = _interopRequireWildcard(require("./permission"));

var _session = _interopRequireWildcard(require("./session"));

var _skybox = _interopRequireWildcard(require("./skybox"));

var _mfa = _interopRequireWildcard(require("./mfa"));

var _notifications = _interopRequireWildcard(require("./notifications"));

var _notificationsBucket = _interopRequireWildcard(require("./notifications-bucket"));

var _utils = _interopRequireWildcard(require("./utils"));

var _auth = _interopRequireWildcard(require("./auth"));

var _profile = _interopRequireWildcard(require("./profile"));

var _core = _interopRequireWildcard(require("./core"));

var _i18n = _interopRequireWildcard(require("./i18n"));

var _logging = _interopRequireWildcard(require("./logging"));

var _licenses = _interopRequireWildcard(require("./licenses"));

var _help = _interopRequireWildcard(require("./help"));

var _privacyPolicy = _interopRequireWildcard(require("./privacy-policy"));

var version = "7.10.1";
var name = "@onviobr/services";
var environment = _environment;
exports.environment = environment;
var preference = _preference;
exports.preference = preference;
var access = _access;
exports.access = access;
var analytics = _analytics;
exports.analytics = analytics;
var permission = _permission;
exports.permission = permission;
var session = _session;
exports.session = session;
var skybox = _skybox;
exports.skybox = skybox;
var mfa = _mfa;
exports.mfa = mfa;
var notifications = _notifications;
exports.notifications = notifications;
var notificationsBucket = _notificationsBucket;
exports.notificationsBucket = notificationsBucket;
var utils = _utils;
exports.utils = utils;
var auth = _auth;
exports.auth = auth;
var profile = _profile;
exports.profile = profile;
var core = _core;
exports.core = core;
var i18n = _i18n;
exports.i18n = i18n;
var logging = _logging;
exports.logging = logging;
var licenses = _licenses;
exports.licenses = licenses;
var help = _help;
exports.help = help;
var privacyPolicy = _privacyPolicy;
exports.privacyPolicy = privacyPolicy;
(0, _appInfo.registerLibrary)({
  version: version,
  name: name
});
